export const GET_ALL_PROJECT : String = "GET_ALL_PROJECT";
export const PROJECT_DATA_LOADING : String = "PROJECT_DATA_LOADING";
export const PROJECT_DATA : String = "PROJECT_DATA";
export const LOADING : String = "LOADING";

